export default "__VITE_ASSET__BcJc2A$x__"